import React, { useEffect, useRef, useState } from 'react'
import { AutoSizer, CellMeasurer, CellMeasurerCache, List } from 'react-virtualized'
import 'react-virtualized/styles.css'
import NotificationItem from './NotificationItem'
import { HEADER_HEIGHT } from '../../layouts/AuthorizedLayout'
import { useFetchNotificationsQuery } from '../../../store/apis/notification.api'

const NotificationsList = () => {
    const [page, setPage] = useState(1)
    const { data, isFetching } = useFetchNotificationsQuery({ page })

    const fetchMoreNotifications = () => {
        if (!isFetching && data?.totalPages > page) {
            setPage(page + 1)
        }
    }

    const cacheRef = useRef(
        new CellMeasurerCache({
            fixedWidth: true,
            defaultHeight: 100,
        }),
    )

    const listRef = useRef(null)

    useEffect(() => {
        if (listRef.current && data?.notifications) {
            cacheRef.current.clearAll()
            listRef.current.recomputeRowHeights()
        }
    }, [data?.notifications])

    const rowRenderer = ({ index, key, parent, style }) => {
        const notification = data?.notifications[index]
        const notificationKey = notification?.id || key
        return (
            <CellMeasurer
                key={notificationKey}
                cache={cacheRef.current}
                parent={parent}
                columnIndex={0}
                rowIndex={index}
            >
                {({ measure }) => (
                    <div style={{ ...style, paddingRight: 12, marginTop: 4 }} onLoad={measure}>
                        <NotificationItem {...notification} />
                    </div>
                )}
            </CellMeasurer>
        )
    }

    const handleScroll = ({ clientHeight, scrollHeight, scrollTop }) => {
        if (scrollHeight - scrollTop <= clientHeight * 2) {
            fetchMoreNotifications()
        }
    }

    return (
        <div style={{ height: `calc(100vh - ${HEADER_HEIGHT}px - 460px)`, width: 340 }}>
            <AutoSizer>
                {({ width, height }) => (
                    <List
                        ref={instance => {
                            listRef.current = instance
                            if (listRef.current) {
                                cacheRef.current.clearAll()
                                listRef.current.recomputeRowHeights()
                            }
                        }}
                        width={width}
                        height={height}
                        deferredMeasurementCache={cacheRef.current}
                        rowHeight={cacheRef.current.rowHeight}
                        rowCount={data?.notifications.length || 0}
                        rowRenderer={rowRenderer}
                        overscanRowCount={10}
                        onScroll={handleScroll}
                    />
                )}
            </AutoSizer>
        </div>
    )
}

export default NotificationsList
